<template>
  <div class="main">
    <div
      class="card-header bg-success mx-auto"
      style="color: white; width: 80%"
    >
      OTHER DETAILS
    </div>
    <div>
      <!-- Delivery additional comments starts-->
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9">
          <v-card
            color="#ffffff"
            class="question_cards"
            style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
          >
            <div class="question_number">
              <span>6</span>
            </div>
            <div class="deliveryinstructions box">
              <h4>{{ deliveryinstructionsmessage }}</h4>
              <textarea
                v-model="bind_deliveryInstructions"
                cols="20"
                rows="4"
                placeholder="Add instructions here..."
                class="pa1 text_area"
                @change="maintainSessionStorage()"
              ></textarea>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- Delivery additional comments ends-->
      <!-- Delivery contact details starts-->
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9">
          <v-card
            color="#ffffff"
            class="question_cards"
            style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
          >
            <div class="question_number">
              <span>7</span>
            </div>
            <v-fade-transition>
              <v-overlay
                :absolute="true"
                :value="
                  overlay[0] &&
                  $v.deliveryName.required &&
                  $v.deliveryPhone.minLength &&
                  $v.deliveryPhone.required
                "
              >
                <i
                  class="fa fa-check updateAnimation"
                  style="font-size: 60px; color: green"
                ></i>
              </v-overlay>
            </v-fade-transition>
            <div class="contactinfo box">
              <h4>
                Please Confirm Your Delivery Contact
                <strong
                  v-if="
                    !(
                      $v.deliveryName.required &&
                      $v.deliveryPhone.minLength &&
                      $v.deliveryPhone.required
                    )
                  "
                  style="color: red; font-size: 18px"
                  >*</strong
                >
              </h4>
              <h6>{{ deliverycontactmessage }}</h6>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="4">
                  <div class="deliverycontact box">
                    <v-text-field
                      label="Name"
                      id="DeliveryName"
                      v-model="bind_deliveryName"
                      solo
                      :hint="
                        !$v.deliveryName.required ? 'Full Name Is Required' : ''
                      "
                      @change="handleUserInputUpdate(0)"
                    >
                      <v-icon slot="prepend" color="#6dbe45">
                        mdi-account
                      </v-icon></v-text-field
                    >
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <div class="deliverycontact box">
                    <v-text-field
                      label="Phone"
                      id="DeliveryPhone"
                      v-model="bind_deliveryPhone"
                      solo
                      @change="handleUserInputUpdate(0)"
                      :hint="
                        !$v.deliveryPhone.minLength
                          ? 'Please enter a 10-digit phone number'
                          : ''
                      "
                      maxlength="14"
                    >
                      <v-icon slot="prepend" color="#6dbe45">
                        mdi-phone-message
                      </v-icon></v-text-field
                    >
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- Delivery contact details ends-->
    </div>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import { enforceFormat, formatToPhone } from "@/JS/FormatPhoneNumber";

export default {
  name: "OtherDetails",
  data() {
    return {
      deliveryinstructionsmessage:
        "If applicable, please provide delivery instructions that we should know about (business hours, special directions, etc.):",
      deliverycontactmessage:
        "Please ensure the driver will have accurate contact information to avoid any delays or missed delivery attempts. Please note that the customer may be charged a dry run fee if we're unable to safely deliver on the scheduled delivery date.",
      phoneNumberElement: null,
      overlay: [false],
    };
  },
  computed: {
    ...mapGetters({
      deliveryName: types.DELIVERY_NAME,
      deliveryPhone: types.DELIVERY_PHONE,
      deliveryInstructions: types.DELIVERY_INSTRUCTIONS,
      predelivery: types.PREDELIVERYANSWERS,
    }),
    bind_deliveryInstructions: {
      get() {
        return this.deliveryInstructions;
      },
      set(value) {
        this.updateDeliveryInstructions(value);
      },
    },
    bind_deliveryName: {
      get() {
        return this.deliveryName;
      },
      set(value) {
        this.updateDeliveryName(value);
      },
    },
    bind_deliveryPhone: {
      get() {
        return this.deliveryPhone;
      },
      set(value) {
        this.updateDeliveryPhone(value);
      },
    },
  },
  validations: {
    deliveryPhone: {
      required,
      minLength: minLength(14),
    },
    deliveryName: {
      required,
    },
  },
  mounted() {
    //Add Event Listener to auto format phone number
    this.phoneNumberElement = document.getElementById("DeliveryPhone");
    this.phoneNumberElement.addEventListener("keydown", enforceFormat);
    this.phoneNumberElement.addEventListener("keyup", formatToPhone);
  },
  beforeDestroy() {
    //Remove Event Listener which was added on phone number
    this.phoneNumberElement.removeEventListener("keydown", enforceFormat);
    this.phoneNumberElement.removeEventListener("keyup", formatToPhone);
  },
  methods: {
    ...mapActions({
      updateDeliveryName: types.ACTIONS_UPDATE_DELIVERY_NAME,
      updateDeliveryPhone: types.ACTIONS_UPDATE_DELIVERY_PHONE,
      updateDeliveryInstructions: types.ACTIONS_UPDATE_DELIVERY_INSTRUCTIONS,
    }),
    handleUserInputUpdate(idx) {
      //Check animation will appear for 1 second
      this.$set(this.overlay, idx, true);
      setTimeout(() => {
        this.$set(this.overlay, idx, false);
      }, 300);
      this.maintainSessionStorage();
    },
    maintainSessionStorage() {
      const predelivery = JSON.stringify(this.predelivery);
      sessionStorage.setItem("predelivery", predelivery);
    },
  },
};
</script>

<style scoped>
h5,
textarea {
  font-size: 14px;
  font-weight: normal;
}

h4 {
  font-size: 18px;
  font-weight: bold;
}

h6 {
  font-style: italic;
  font-size: 15px;
  margin-bottom: 20px;
}

label {
  font-size: 14px;
  font-weight: normal;
}
.box {
  color: #00587d;
}

.question_cards {
  padding-top: 30px;
  padding-bottom: 5px;
  margin: 20px;
  padding-left: 5px;
  padding-right: 5px;
  overflow: hidden;
}

.question_number {
  background-color: #6dbe45;
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.8);
  height: 70px;
  left: -50px;
  position: absolute;
  top: -50px;
  width: 100px;
  -webkit-transform: rotate(-45deg);
}

.question_number span {
  color: #f5f5f5;
  font-family: sans-serif;
  font-size: 0.8em;
  left: 5px;
  top: 52px;
  position: absolute;
  width: 70px;
}

.text_area {
  border: 2px solid #c7c7c7;
  color: black;
  background-color: white;
  border-radius: 3px;
  width: 60%;
}
.dialog {
  background-color: white;
  border-radius: 15px;
  padding: 15px;
}

@media only screen and (max-width: 760px) {
  .text_area {
    width: 100%;
  }
}
</style>
